import classNames from 'classnames';

export interface ViewSetting {
  contentMaxHeight: string;
  iconClassName: string;
}

export const getViewSetting = (active: boolean, scrollHeight?: number): ViewSetting => {
  const iconClassName: string = classNames({
    'users-section__icon': true,
    'users-section__icon--rotate': active && scrollHeight,
  });

  return {
    contentMaxHeight: `${active ? scrollHeight || 0 : 0}px`,
    iconClassName,
  };
};
